<template>
  <div>
    <div class="main">
      <BannerSlider />

      <MarqueeBar
        :show="!threedData.embedded_link && !threedData.isLive"
        :text="websiteInfo.noticeText"
      />

      <TabList
        :tabs="[
          {
            value: 'hot',
            label: $t('home.hot'),
            icon: require('@/assets/images/tabs/hot.avif'),
          },
          {
            value: 'buffalo',
            label: $t('home.buffalo'),
            icon: 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/buffalo_icon.webp',
          },
          {
            value: 'slot',
            label: $t('home.slot'),
            icon: require('@/assets/images/tabs/slot.avif'),
          },
          {
            value: 'card',
            label: $t('home.card'),
            icon: require('@/assets/images/tabs/card.avif'),
          },
          {
            value: 'fishing',
            label: $t('home.fishing'),
            icon: require('@/assets/images/tabs/fish.avif'),
          },
          {
            value: 'live',
            label: $t('home.lc'),
            icon: require('@/assets/images/tabs/girl.avif'),
          },
          {
            value: 'sport',
            label: $t('home.football'),
            icon: require('@/assets/images/tabs/sport.avif'),
          },
          {
            value: 'arcade',
            label: $t('home.arcade'),
            icon: require('@/assets/images/tabs/ball.avif'),
          },
        ]"
        :active="$store.state.sideNav"
        @change="changeSideNav"
      />

      <div
        class="index_rightbar"
        id="index_rightbar"
      >
        <div>
          <div class="tab-content game px-2">
            <!-- Hot Games -->
            <div
              class="mx-1"
              :class="$store.state.sideNav === 'hot' ? 'active' : ''"
              v-show="$store.state.sideNav === 'hot'"
            >
              <div>

                <!-- Buffalo Games -->
                <div class="col-12 p-0 py-1 -mt-2">
                  <div class="d-flex">
                    <div class="my-auto mr-2">
                      <img
                        src="https://hj-hashgo.s3.ap-southeast-1.amazonaws.com/80001001/zh-CN/factory_channel_category/hot-1.png?t=11/4/2025"
                        style="width: 1.5rem;"
                      />
                    </div>
                    <div>
                      <h4
                        class="text-nowrap font-semibold pt-1"
                        style="color: white; font-size: 1.3rem !important;"
                      >
                        {{ $t("home.popular_games") }}
                      </h4>
                    </div>
                  </div>

                  <div class="d-flex flex-wrap">
                    <Swiper
                      :modules="[Autoplay]"
                      :slides-per-view="4"
                      :loop="false"
                      :autoplay="{
                        delay: 3300,
                      }"
                      :pagination="{ clickable: true }"
                      :initial-slide="0"
                      class="responsible-swiper"
                      :looped-slides="3.5"
                    >
                      <SwiperSlide
                        v-for="i in 6"
                        :key="i"
                      >
                        <div
                          class="w-full p-1"
                          @click="fetchBuffaloData()"
                        >
                          <div class="w-full h-full relative">
                            <img
                              src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/buffalo688/332.png"
                              alt=""
                              class="w-full h-full"
                              style="border-radius: 8px; overflow: hidden;"
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>


                <!-- Slot Games -->
                <div class="col-12 p-0 py-1 -mt-2">
                  <div class="d-flex">
                    <div class="my-auto mr-2">
                      <img
                        src="https://hj-hashgo.s3.ap-southeast-1.amazonaws.com/80001001/zh-CN/factory_channel_category/slot-1.png?t=12/4/2025"
                        style="width: 1.5rem;"
                      />
                    </div>
                    <div>
                      <h4
                        class="text-nowrap font-semibold pt-1"
                        style="color: white; font-size: 1.3rem !important;"
                      >
                        {{ $t("home.popular_slot_games") }}
                      </h4>
                    </div>
                  </div>

                  <div class="d-flex flex-wrap">
                    <Swiper
                      :modules="[Autoplay]"
                      :slides-per-view="hotGames['slotGames'].length > 3 ? 4 : hotGames['slotGames'].length"
                      :loop="false"
                      :autoplay="{
                        delay: 3300,
                      }"
                      :pagination="{ clickable: true }"
                      :initial-slide="0"
                      class="responsible-swiper"
                      :looped-slides="3.5"
                    >
                      <SwiperSlide
                        v-for="slotGame in hotGames['slotGames']"
                        :key="slotGame.id"
                      >
                        <GameCard
                          @click="gameInit(slotGame)"
                          :game="slotGame"
                        />
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>


                <!-- Fishing Games -->
                <div class="col-12 p-0 py-1 -mt-4">
                  <div class="d-flex">
                    <div class="my-auto mr-2">
                      <img
                        src="https://hj-hashgo.s3.ap-southeast-1.amazonaws.com/80001001/zh-CN/factory_channel_category/fishing-1.png?t=11/4/2025"
                        style="width: 1.5rem"
                      />
                    </div>

                    <div class="my-auto">
                      <h4
                        class="text-nowrap font-semibold"
                        style="color: white; font-size: 1.3rem !important;"
                      >
                        {{ $t("home.popular_fishing_games") }}
                      </h4>
                    </div>
                  </div>

                  <div class="d-flex flex-wrap">
                    <Swiper
                      :modules="[Autoplay]"
                      :slides-per-view="hotGames['fishingGames'].length > 3 ? 4 : hotGames['fishingGames'].length"
                      :loop="true"
                      :autoplay="{
                        delay: 3300,
                      }"
                      :pagination="{ clickable: true }"
                      :initial-slide="0"
                      class="responsible-swiper"
                      :looped-slides="3"
                    >
                      <SwiperSlide
                        v-for="fishingGame in hotGames['fishingGames']"
                        :key="fishingGame.id"
                      >
                        <GameCard
                          @click="
                            fishingGame.provider === 'PGSoft' ||
                              fishingGame.provider === 'FaChai'
                              ? showAlertBox(fishingGame)
                              : gameInit(fishingGame)
                            "
                          :game="fishingGame"
                        />
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>

                <!-- Arcade Games -->
                <div class="col-12 p-0 py-1 -mt-4">
                  <div class="d-flex">
                    <div class="my-auto mr-2">
                      <img
                        src="https://hj-hashgo.s3.ap-southeast-1.amazonaws.com/80001001/zh-CN/factory_channel_category/card-1.png?t=11/4/2025"
                        style="width: 1.5rem"
                      />
                    </div>

                    <div class="my-auto">
                      <h4
                        class="text-nowrap font-semibold pt-0"
                        style="color: white; font-size: 1.3rem !important;"
                      >
                        {{ $t("home.popular_arcade_games") }}
                      </h4>
                    </div>
                  </div>

                  <div class="d-flex flex-wrap">
                    <Swiper
                      :modules="[Autoplay]"
                      :slides-per-view="hotGames['arcadeGames'].length > 3 ? 4 : hotGames['arcadeGames'].length"
                      :loop="true"
                      :autoplay="{
                        delay: 3300,
                      }"
                      :pagination="{ clickable: true }"
                      :initial-slide="0"
                      class="responsible-swiper"
                      :looped-slides="3"
                    >
                      <SwiperSlide
                        v-for="arcadeGame in hotGames['arcadeGames']"
                        :key="arcadeGame.id"
                      >
                        <GameCard
                          @click="gameInit(arcadeGame)"
                          :game="arcadeGame"
                        />
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>

            <!-- SKM Games -->
            <div
              class="!flex items-center flex-wrap mt-4"
              :class="$store.state.sideNav === 'skm' ? 'active' : ''"
              v-if="$store.state.sideNav === 'skm'"
            >
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level0.webp"
                alt="skm"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchShanKoMeeData(0)"
              />
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level1.webp"
                alt="skm"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchShanKoMeeData(1)"
              />
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level2.webp"
                alt="skm"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchShanKoMeeData(2)"
              />
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level3.webp"
                alt="skm"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchShanKoMeeData(3)"
              />
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level4.webp"
                alt="skm"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchShanKoMeeData(4)"
              />
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level5.webp"
                alt="skm"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchShanKoMeeData(5)"
              />
            </div>

            <!-- BGY Games -->
            <div
              class="!flex items-center flex-wrap mt-4"
              :class="$store.state.sideNav === 'bgy' ? 'active' : ''"
              v-if="$store.state.sideNav === 'bgy'"
            >
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level0.webp"
                alt="bgy"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchBugyee(0)"
              />
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level1.webp"
                alt="bgy"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchBugyee(1)"
              />
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level2.webp"
                alt="bgy"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchBugyee(2)"
              />
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level3.webp"
                alt="bgy"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchBugyee(3)"
              />
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level4.webp"
                alt="bgy"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchBugyee(4)"
              />
              <img
                class="mx-1 my-1"
                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rooms/room-th-level5.webp"
                alt="bgy"
                style="cursor: pointer; width: 31%; height: auto"
                @click="fetchBugyee(5)"
              />
            </div>

            <!-- Card Games -->
            <div
              class="pb-2 mx-0 px-0 !grid grid-cols-4 gap-2 mt-3"
              :class="$store.state.sideNav === 'card' ? 'active' : ''"
              v-if="$store.state.sideNav === 'card'"
            >
              <div class="flex flex-col gap-3 justify-center">
                <div
                  class="w-full"
                  @click="changeSideNav('skm')"
                >
                  <div class="w-full h-full relative">
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/game-icons/shankomee.webp"
                      alt=""
                      class="w-full h-full"
                    />
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-3 justify-center">
                <div
                  class="w-full"
                  @click="changeSideNav('bgy')"
                >
                  <div class="w-full h-full relative">
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/game-icons/BuKyee.webp"
                      alt=""
                      class="w-full h-full"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="flex flex-col gap-3 justify-center">
                <div
                  class="w-full h-[120px]"
                  @click="fetchForestData()"
                >
                  <div class="w-full h-full relative">
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/game-icons/shankomee.webp"
                      alt=""
                      class="w-full h-full"
                    />
                  </div>
                </div>
              </div> -->
              <div class="flex flex-col gap-3 justify-center">
                <div
                  class="w-full"
                  @click="fetchGaloneData()"
                >
                  <div class="w-full h-full relative">
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/game-icons/galone%20galone.webp"
                      alt=""
                      class="w-full h-full"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Buffalo Games -->
            <div
              class="pb-2 mx-0 px-0 !grid grid-cols-4 gap-1 mt-3"
              :class="$store.state.sideNav === 'buffalo' ? 'active' : ''"
              v-if="$store.state.sideNav === 'buffalo'"
            >
              <div class="flex flex-col gap-3 justify-center">
                <div
                  class="w-full"
                  @click="fetchBuffaloData()"
                >
                  <div class="w-full h-full relative">
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/africanbuffalo-hot.webp"
                      alt=""
                      class="w-full h-full"
                    />
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-3 justify-center">
                <div
                  class="w-full"
                  @click="fetchBuffaloData()"
                >
                  <div class="w-full h-full relative">
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/africanbuffalo-hot.webp"
                      alt=""
                      class="w-full h-full"
                    />
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-3 justify-center">
                <div
                  class="w-full"
                  @click="fetchBuffaloData()"
                >
                  <div class="w-full h-full relative">
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/africanbuffalo-old.webp"
                      alt=""
                      class="w-full h-full"
                    />
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-3 justify-center">
                <div
                  class="w-full"
                  @click="fetchBuffaloData()"
                >
                  <div class="w-full h-full relative">
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/africanbuffalo-old.webp"
                      alt=""
                      class="w-full h-full"
                    />
                  </div>
                </div>
              </div>
            </div>


            <!-- Sport Games -->
            <!-- <div
              class="pb-2 mx-0 px-0 !grid grid-cols-4 gap-2 mt-3"
              :class="$store.state.sideNav === 'sport' ? 'active' : ''"
              v-if="$store.state.sideNav === 'sport'"
            >
              <div class="flex flex-col gap-3 justify-center">
                <div class="w-full">
                  <div
                    class="w-full h-full relative"
                    @click="gameInit({ gameID: 'PINN_1' })"
                  >
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/game-icons/AP%20Gaming.webp"
                      alt=""
                      class="w-full h-full"
                    />
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-3 justify-center">
                <div class="w-full">
                  <div
                    class="w-full h-full relative"
                    @click="gameInit({ gameID: 'SABA_1' })"
                  >
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/game-icons/SABA.webp"
                      alt=""
                      class="w-full h-full"
                    />
                  </div>
                </div>
              </div>
            </div> -->

            <!-- Sport Games -->
            <div
              class="pb-3 !grid grid-cols-4 gap-2 mt-3"
              :class="$store.state.sideNav === 'sport' ? 'active' : ''"
              v-if="$store.state.sideNav === 'sport'"
            >
              <ProviderCard
                v-for="provider in sportProviders"
                :key="provider.id"
                :provider="provider"
                category="SPORT"
                @click="$router.push(`/user/sport?provider=${provider.code}`)"
              />
            </div>

            <!-- Fishing Games -->
            <div
              class="pb-3 !grid grid-cols-4 gap-2 mt-3"
              :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
              v-if="$store.state.sideNav === 'fishing'"
            >
              <ProviderCard
                v-for="provider in fishProviders"
                :key="provider.id"
                :provider="provider"
                category="FISH"
                @click="$router.push(`/user/fishing?provider=${provider.code}`)"
              />
            </div>

            <!-- Slot Providers -->
            <div
              :class="$store.state.sideNav === 'slot' ? 'active' : ''"
              v-if="$store.state.sideNav === 'slot'"
              class="pb-2 mx-0 px-0 !grid gap-2 mt-3 grid-cols-4"
            >
              <ProviderCard
                v-for="provider in slotProviders"
                :key="provider.id"
                :provider="provider"
                category="SLOTS"
                @click="$router.push(`/user/slots?provider=${provider.code}`)"
              />
            </div>

            <!-- Arcade Games -->
            <div
              :class="$store.state.sideNav === 'arcade' ? 'active' : ''"
              v-if="$store.state.sideNav === 'arcade'"
              class="!grid grid-cols-4 gap-2 mt-3"
            >
              <ProviderCard
                v-for="provider in arcadeProviders"
                :key="provider.id"
                :provider="provider"
                category="POKER"
                @click="$router.push(`/user/arcade?provider=${provider.code}`)"
              />
            </div>

            <!-- Live Providers -->
            <div
              :class="$store.state.sideNav === 'live' ? 'active' : ''"
              v-if="$store.state.sideNav === 'live'"
              class="!grid grid-cols-4 gap-2 mt-3"
            >
              <ProviderCard
                v-for="provider in liveProviders"
                :key="provider.id"
                :provider="provider"
                category="LIVE"
                @click="$router.push(`/user/live?provider=${provider.code}`)"
              />
            </div>

            <footer class="page-footer-copyright mt-4">

              <div
                class="footer-platform num-27 d-flex flex-wrap justify-content-center"
                bis_skin_checked="1"
              >

                <img
                  class="ACEWIN"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/ACEWIN-logo.webp"
                >

                <img
                  class="ADVANTPLAY"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/ADVANTPLAY-logo.webp"
                >

                <img
                  class="ILOVEU"
                  src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/iloveu.webp"
                >

                <img
                  class="BNG"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/BNG-logo.webp"
                >

                <img
                  class="DG"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/DG-logo.webp"
                >

                <img
                  class="FACHAI"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/FACHAI-logo.webp"
                >

                <img
                  class="ALIZE"
                  src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/alize.png"
                >

                <img
                  class="JDB"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/JDB-logo.webp"
                >

                <img
                  class="JILI"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/JILI-logo.webp"
                >

                <img
                  class="KINGMIDAS"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/KINGMIDAS-logo.webp"
                >

                <img
                  class="MGGAMING"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/MGGAMING-logo.webp"
                >

                <img
                  class="MGLIVE"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/MGLIVE-logo.webp"
                >

                <!-- <img class="MIMI" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/MIMI-logo.webp"> -->

                <img
                  class="POCKET"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/POCKET-logo.webp"
                >

                <!-- <img class="PLAYSTAR" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/PLAYSTAR-logo.webp"> -->

                <img
                  class="PP"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/PP-logo.webp"
                >

                <!-- <img class="SEXYBCRT" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/SEXYBCRT-logo.webp"> -->

                <img
                  class="SPADE"
                  src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/SPADE-logo.webp"
                >

                <!-- <img class="SVCASINO" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/SVCASINO-logo.webp"> -->

                <!-- <img class="SVSPORTS" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/SVSPORTS-logo.webp"> -->

                <!-- <img class="TWOJGAME" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/TWOJGAME-logo.webp"> -->

                <!-- <img class="VERTEXPLAY" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/VERTEXPLAY-logo.webp"> -->

                <!-- <img class="WM" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/WM-logo.webp"> -->

                <!-- <img class="WMSLOT" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/WMSLOT-logo.webp"> -->

                <!-- <img class="WOS" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/WOS-logo.webp"> -->

                <!-- <img class="YB" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/YB-logo.webp"> -->

                <!-- <img class="CARD365" src="https://land2.mpsimg.com/theme/images/src-common/PLATFORM-img/120x80-fullname/CARD365-logo.webp"> -->

                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/bgaming_dark.png">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/evolution_logo.png">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/EvolutionNetEnt.png">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/Evoplay.png">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/Ezugi.png">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/hanebar.png">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/hacksaw_logo.webp">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/live88.png">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/nolimit-logo.png">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/Play_n%20GO.png">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/RedTiger.png">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/SABA%20Sport.png">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/spinomenal.webp">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/turbo_games.webp">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/winfinity_logo.webp">
                <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/Yeebet.webp">



              </div>

              <div
                class="page-wrapper"
                style="display:none"
                bis_skin_checked="1"
              >
                <div
                  class="brand-area socialnum-0"
                  bis_skin_checked="1"
                >


                </div>
              </div>
              <div
                class="page-wrapper mt-3"
                bis_skin_checked="1"
              >
                <div
                  class="txt-copyright customInfo"
                  bis_skin_checked="1"
                >Agent များမှငွေထုတ်ပေးခြင်းမရှိပါက၊ <br> တိုက်ရိုက်တိုင်ကြားရန် Telegram <a
                    href="https://t.me/sabai88th"
                    bis_skin_checked="1"
                    class="text-white"
                  >@sabai88th</a> ကို အချိန်မရွေးဆက်သွယ်နိုင်ပါတယ်ရှင့်။</div>
                <div
                  class="txt-copyright"
                  bis_skin_checked="1"
                ><br> © Sabai88 All rights Reserved<br>All content, image, and logo are respected property of Sabai88
                  and protected by copyright law.</div>
                <div
                  class="txt-support"
                  bis_skin_checked="1"
                >
                  <p>Our platform is most compatible with:</p><span class="badge text-center"><img
                      src="https://land2.mpsimg.com/theme/images/src-common/FOOTER-img/browser/chrome.png"
                      class="mx-auto"
                    >Google Chrome</span><span class="badge"><img
                      src="https://land2.mpsimg.com/theme/images/src-common/FOOTER-img/browser/safari.png"
                      class="mx-auto"
                    >Safari</span>
                </div>
                <div
                  class="policy-area-menu"
                  bis_skin_checked="1"
                ><a
                    class="txt-link"
                    onclick="#"
                  >Responsible Gaming Policy</a><a
                    class="txt-link"
                    onclick="#"
                  >21+ Responsible Gaming</a></div>
              </div>
            </footer>

          </div>
        </div>
      </div>
    </div>

    <van-overlay :show="isLoading">
      <div
        class="wrapper"
        @click.stop
      >
        <van-loading
          type="spinner"
          color="#ffffff"
          class="mx-auto"
        />
      </div>
    </van-overlay>

    <div class="col-4">
      <div
        class="modal fade"
        id="limit"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        @click="hideLimit()"
      >
        <div
          class="modal-dialog modal- modal-dialog-centered"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body my-5 mx-3 text-center">
              <span class="text-danger text-lg">
                <b>အထူးသတိပြုရန်။</b> <br /><br />
              </span>
              <span>{{ limitText }}</span>
              <br /><br />
              <span class="text-dark text-sm">
                <button
                  class="btn btn-danger"
                  @click="gameInit(desiredGame)"
                >
                  {{
                    $store.state.language === "en"
                      ? "Play The Game"
                      : "ဂိမ်းဆော့မည်။"
                  }}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { NoticeBar, Dialog, Toast, Sticky } from "vant";
import { LiveChatWidget } from "@livechat/widget-vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Autoplay } from "swiper/modules";

import TabItem from "@/components/home/TabItem.vue";
import BannerSlider from "@/components/home/BannerSlider.vue";
import MarqueeBar from "@/components/home/MarqueeBar.vue";
import TabList from "@/components/home/TabList.vue";
import GameCard from "@/components/home/GameCard.vue";
import ProviderCard from "@/components/ProviderCard.vue";
import HotGames from "@/components/home/HotGames.vue";

export default {
  components: {
    NoticeBar,
    Sticky,
    LiveChatWidget,
    Swiper,
    SwiperSlide,

    ProviderCard,
    GameCard,
    BannerSlider,
    MarqueeBar,
    TabItem,
    TabList,
    HotGames
  },
  data() {
    return {
      testing: true,
      isLoading: false,
      twoDdata: {},
      twoDHistories: {},
      threeDHistories: {},
      threedData: {},
      websiteInfo: {
        home_banners: {},
        noticeText: "This is a notice",
      },
      activeNoticeText: "",
      isLogged: false,
      hotGames: {
        slotGames: [],
        fishingGames: [],
        arcadeGames: [],
      },
      limitText: "",
      desiredGame: null,
    };
  },
  computed: {
    ...mapState('providers', [
      'slotProviders',
      'fishProviders',
      'arcadeProviders',
      'liveProviders',
      'sportProviders',
      'isProvidersFetching',
    ]),
  },
  methods: {
    ...mapActions('providers', ['fetchActiveProviders']),

    async fetchBuffaloData(type = null) {
      try {
        this.$store.commit('setLoading', true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        let res = null;

        if (type === 'new') {
          res = await axios.get("/new-buffalo-data", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
        } else {
          res = await axios.get("/buffalo-data", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
        }

        if (res.data.gameURL) {
          // window.top.location.href = res.data.gameURL
          if (this.isMobile && this.isPWA()) {
            this.$store.commit("setIframeURL", res.data.gameURL);
            this.$router.push("/iframeURL");
          } else {
            window.top.location.href = res.data.gameURL;
          }
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.$store.commit('setLoading', false);
      } catch (error) {
        this.$store.commit('setLoading', false);
        console.log(error);
      }
    },

    async gameInitCasino(game) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const res = await axios.get(
          "https://api.shwespin777.com/api/games/url",
          {
            params: {
              provider: game,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        window.location.assign(res.data.data.gameUrl);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    hideLimit() {
      $("#limit").modal("hide");
    },
    showAlertBox(game) {
      if (game.provider === "PGSoft")
        this.limitText = "PG Soft တွင် 1K unit သည် 1,000 ကျပ်နှင့်ညီမျပါသည်။";
      else if (game.provider === "FaChai")
        this.limitText =
          "FaChai Provider တွင် 1 unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။";
      // else this.limitText = '5G Provider တွင် 1K unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။';
      $("#limit").modal("show");
      this.desiredGame = game;
    },

    async gameInit(game) {
      try {
        this.$store.commit("setLoading", true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        let providerID = this.$route.query.provider;
        const res = await axios.get("/games/url",
          {
            params: {
              gameID: game.gameID,
              provider: providerID,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        window.open(res.data.data.gameUrl, "_self");

        this.$store.commit("setLoading", false);
      } catch (error) {
        this.$store.commit("setLoading", false);
      }
    },

    scrollToElement() {
      const container = this.$el.querySelector(".index_rightbar");
      // Scroll to the target element within the container
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    async fetchBetGame(game = null, link = null) {
      try {
        this.isLoading = true;

        if (game) {
          this.gameName = game;
          this.gameLink = link;
        }
        const res = await axios.get(`/${this.gameName}-data`, {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
        });
        window.location.assign(
          `https://${link}.vercel.app/?id=${this.$store.state.authUser.name}&passcode=${res.data.passcode}&exit=https%3A%2F%2F${window.location.host}/home`
        );
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchForestData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/forest-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data.gameURL) {
          window.location.assign(res.data.gameURL);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchGaloneData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/galone-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data.gameURL) {
          window.location.assign(res.data.gameURL);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchGaloneGalone() {
      if (this.$store.state.authUser.game_balance < 1000) {
        this.alertBoxForLimit();
        return false;
      }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/galone-galone", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data.gameURL) {
          window.location.assign(res.data.gameURL);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchBugyee(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 50) {
          this.limitText =
            "50 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 500) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 100) {
          this.limitText =
            "100 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 1000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 150) {
          this.limitText =
            "150 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 1500) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 200) {
          this.limitText =
            "200 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 250) {
          this.limitText =
            "250 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 300) {
          this.limitText =
            "300 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        const res = await axios.get("/bugyee-data", {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // console.log(res.data)
        // window.location.assign(res.data.url);
        if (res.data.gameURL) {
          window.location.assign(res.data.gameURL);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchShanKoMeeData(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 50) {
          this.limitText =
            "50 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 500) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 100) {
          this.limitText =
            "100 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 1000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 150) {
          this.limitText =
            "150 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 1500) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 200) {
          this.limitText =
            "200 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 250) {
          this.limitText =
            "250 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 300) {
          this.limitText =
            "300 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/shankomee-data", {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // console.log(res.data)
        // window.location.assign(res.data.url);
        if (res.data.gameURL) {
          window.location.assign(res.data.gameURL);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }


        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    changeSideNav(para) {
      this.$store.commit("updateSideNav", para);
      this.scrollToElement();
    },
    ...mapActions(["logoutUser", "fetchUser"]),
    async redirectRoute(path, query = null) {
      try {
        console.log("query", query);
        if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },

    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === "en"
            ? "Are you sure to log out?"
            : "ထွက်မှာ သေချာပါသလား?",
        cancelButtonText:
          this.$store.state.language === "en" ? "Cancel" : "မထွက်တော့ပါ",
        confirmButtonText:
          this.$store.state.language === "en" ? "Sure" : "သေချာပြီ",
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push("/auth/login");
          Toast.success(
            this.$store.state.language === "en" ? "Logged out!" : "ထွက်ပြီးပြီ"
          );
        })
        .catch(() => { });
    },
    async redirectRoute(path, query = null) {
      try {
        if (path === "tip") {
          const text =
            this.$store.state.language === "en"
              ? "This feature is not support yet."
              : "ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။";
          Dialog.alert({
            message: text,
            confirmButtonText:
              this.$store.state.language === "en" ? "Okay" : "Okay",
          }).then(() => {
            // on close
          });
        } else if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },
    threedDrawDateFormat(date) {
      return moment(date).format("ll");
    },
    async fetchTwoDdata() {
      try {
        const res = await axios.get("/2d/data");
        this.isLive = res.data.data[0].isLive;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get("/website-infos");
        const activeNoticeTextResponse = await axios.get("/active-notice");
        // console.log("ACTIVE NOCIE TEXT", activeNoticeTextResponse);
        this.websiteInfo = res.data.data[0];
        this.activeNoticeText = activeNoticeTextResponse.data.active_notice;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchThreedDdata() {
      try {
        const res = await axios.get("/3d/data");
        this.threedData = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchHotGames() {
      try {
        const { data } = await axios.get("/hot-games");
        this.hotGames = data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoThreeDHistories() {
      try {
        const twoDres = await axios.get("/twod_history");
        const threeDres = await axios.get("/threed_history");
        this.twoDHistories = twoDres.data.data;
        this.threeDHistories = threeDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    // Function to load the Tawt.io chat widget
    // loadTawkChat() {
    //   console.log('here1')
    //   if (!document.getElementById('tawk-io-chat')) {
    //     console.log('here2')
    //     var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();

    //     // Dynamically add the script to load Tawt.io
    //     var s1 = document.createElement("script");
    //     var s0 = document.getElementsByTagName("script")[0];
    //     s1.async = true;
    //     s1.id = 'tawk-io-chat';
    //     s1.src = 'https://embed.tawk.to/66ed95584cbc4814f7dc1919/1i880up29';
    //     s1.charset = 'UTF-8';
    //     s1.setAttribute('crossorigin', '*');
    //     s0.parentNode.insertBefore(s1, s0);

    //     // Apply custom styles when the widget loads
    //     Tawk_API.onLoad = () => {
    //       this.applyCustomStyles();
    //       setInterval(this.applyCustomStyles, 1000);
    //     };
    //   }
    // },
    // Function to apply custom styles to the Tawk.to iframe
    // applyCustomStyles() {
    //   var tawkIframe = document.querySelector('iframe[title="chat widget"]');
    //   if (tawkIframe) {
    //     tawkIframe.style.bottom = '7rem'; // Adjust this as needed
    //     tawkIframe.style.left = '1rem';
    //     tawkIframe.style.right = '0rem';
    //   }
    // },
    // // Function to remove the Tawt.io script and widget
    // removeTawkChat() {
    //   const tawkScript = document.getElementById('tawk-io-chat');
    //   if (tawkScript) {
    //     tawkScript.remove(); // Remove the script tag
    //   }

    //   // Remove the Tawk.to iframe widget
    //   const tawkIframe = document.querySelector('iframe[title="chat widget"]');
    //   if (tawkIframe) {
    //     tawkIframe.remove();
    //   }
    // }
  },
  setup() {
    return {
      Pagination,
      Autoplay,
    };
  },
  destroyed() {
    this.testing = false;
  },
  async mounted() {
    this.$store.commit("setLoading", true);
    await this.fetchWebsiteData();
    await this.fetchHotGames();
    await this.fetchActiveProviders();
    this.$store.commit("setLoading", false);
  },
  beforeDestroy() {
    // this.removeTawkChat();
  },
};
</script>

<style scoped>
footer.page-footer-copyright {
  font-size: 80%;
  text-align: center;
  color: #ffffffa4;
  position: relative;
  padding: 0 0 60px 0;
}

.footer-platform {
  display: block;
  padding: 1% 2%;
  margin: 0 auto 1% auto;
  text-align: center;
  position: relative;
}

footer.page-footer-copyright {
  font-size: 80%;
  text-align: center;
  color: #ffffffa4;
  position: relative;
  padding: 0 0 60px 0;
}

.footer-platform img,
.page-wrapper img {
  width: 55px;
  margin: 0 5px;
  height: 40px;
  object-fit: contain;
}

footer.page-footer-copyright .txt-support {
  display: inline-block;
  border-radius: 15px;
  /* background-color: rgba(0, 0, 0, 0.3); */
  padding: 10px;
  margin: 0 auto;
  color: #ffffff7a;
}

footer.page-footer-copyright .txt-support .badge {
  margin-right: 10px;
  line-height: 25px;
  padding: 0;
  font-weight: normal;
  font-size: 12px;
}

footer .txt-support .badge img,
.modal-content .txt-support .badge img {
  width: 20px;
  height: 20px;
  margin-right: 3px;
  vertical-align: middle;
}

.page-web.M9 .page-wrapper {
  background: rgba(13, 38, 34, 0.7);
}

footer.page-footer-copyright .page-wrapper {
  font-size: 12px;
  background: transparent !important;
}

.page-web .page-wrapper {
  width: 100%;
  margin: 0 auto;
}

footer .page-wrapper,
.modal-content .page-wrapper {
  padding: 0;
}

footer.page-footer-copyright {
  font-size: 80%;
  text-align: center;
  color: #ffffffa4;
  position: relative;
  padding: 0 0 60px 0;
}

.txt-link {
  color: #924AFF !important;
}

.main {
  position: relative;
  height: 100%;
}

.pulse {
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}


@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.side-nav-icon-text {
  /* color: #A80000; */
  font-size: 0.9rem;
  /* color: #382618; */
}

.side-nav-icon {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  font-weight: 600;
  color: #ccc !important;
  background: transparent;
  border: 1px solid #434f64;
  /* box-shadow: rgba(40, 40, 40, 0.4) 0 2px 4px, rgba(40, 40, 40, 0.4) 0 7px 13px -3px, #000000 0 0 0 inset; */
  /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */
}

.side-nav-icon.active {
  /* background: #A80000; */
  /* background: linear-gradient(10deg,#CF05D2,#e8a3e9); */
  /* color: black !important; */
  /* box-shadow: rgba(40, 40, 40, 0.4) 0 2px 4px, rgba(40, 40, 40, 0.4) 0 7px 13px -3px, #01ff3c 0 -3px 0 inset; */
  border: 1px solid #d2a038 !important;
}

.side-nav-icon-text.active {
  background: #c7a241;
  color: black;
  /* padding: 1px 10px; */
  border: none;
  width: 90%;
  text-align: center;
  border-radius: 5px;
  /* font-weight: bold; */
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  /* font-size: 16px; */
}

.sidebar {
  position: fixed;
  left: 0;
  height: 55vh;
  padding-bottom: 50px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-y: auto;
}

.index_rightbar {
  height: 100%;
  width: 100%;
  padding-bottom: 15rem;
  position: absolute;
  background: #12102e;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.detail-button {
  appearance: none;
  background-color: transparent;
  border: 2px solid #714dc7;
  text-transform: uppercase;
  border-radius: 10px;
  box-sizing: border-box;
  color: #714dc7;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(0.23, 1, 0.32, 1);
  user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background-color: #714dc7;
  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
}

.nav-pills.game-nav {
  padding-right: 5px;
}

.nav-pills .nav-link {
  border-radius: 10px !important;
  margin-bottom: 5px;
  font-size: 10px !important;
  text-align: center;
  color: #ffffff;
}

.nav-item {
  padding-right: 0;
  margin-bottom: 0;
  width: 12rem;
}

.nav-pills .nav-link img {
  width: 18px !important;
  padding-bottom: 4px;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #fff !important;
  background: linear-gradient(#fff, #8a69d9);
}

.nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.tab-content.game a img {
  border-radius: 21px;
  margin-bottom: 10px;
  width: 100%;
}

.tab-content.game {
  padding-left: 3px;
  padding-bottom: 10rem;
}

.tab-content>.tab-pane {
  display: none;
  padding-right: 3px;
}

.tab-content>.active {
  display: block;
}

.card {
  cursor: pointer;
  border-radius: 10px !important;
}

.video-container {
  height: 500px;
  width: 100%;
}

.twod-threed-cards {
  height: 200px;
}

.live-number {
  font-weight: bold;
  font-size: 25px;
}

.live-result {
  font-weight: bolder;
  font-size: 60px;
  animation-name: live-number-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.not-live-text {
  font-weight: bold;
  font-size: 24px;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
}

.card-body {
  padding: 0px !important;
}

@keyframes live-number-animation {
  from {
    color: white;
  }

  to {
    color: red;
  }
}

hr {
  margin-top: 0px;
  margin-bottom: 0px;
}

.video-container {
  height: 300px;
  width: 100%;
}

.live-number {
  font-weight: bold;
  font-size: 20px;
}

.live-result {
  font-weight: bolder;
  font-size: 37px;
}

.cards-container {
  display: none;
}

.home-cards {
  padding-left: 10px;
  padding-right: 10px;
}

.card-body {
  padding: 0px !important;
}

.not-live-text {
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
}

.account-container-wrapper {
  width: auto;
  height: auto;
  border-radius: 10px;
  padding-left: 4px;
  padding-right: 4px;
  margin-top: 10px !important;
  margin-left: 10px;
  margin-right: 10px;
  color: #000000;
  /* background: linear-gradient(#aa9ace, #714DC7); */
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.top-wrapper,
.bottom-wrapper {
  padding: 10px;
  width: 100%;
  display: flex;
}

.top-right,
.bottom-right {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: end;
}

.top-left,
.bottom-left {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: start;
}

.info-swiper .swiper-slide {
  transition: transform 0.4s ease, opacity 0.4s ease;
  transform: scale(0.9);
  opacity: 0.5;
}

.info-swiper .swiper-slide-active {
  transform: scale(1);
  opacity: 1;
}

/* } */
</style>
